<template>
  <div v-if="$companyConfiguration.talentMatrix.isEnabled()">
    <back-link v-show="$canAndRulesPass(user, 'talent_matrix.matrix_see_in_menu')" :link="{ name: 'TalentMatrices' }" text="в матрицы талантов" margin="0 0 20px 0"></back-link>
    <page-heading :heading="matrix.name"></page-heading>
    <div>
      <el-tabs :value="tabValue">
        <el-tab-pane v-if="$canAndRulesPass(matrix, 'talent_matrix.matrix_update')" label="Настройки матрицы" name="matrix_setting">
          <el-card>
            <talent-matrix-setting
              :matrix="matrix"
              :loading="loading"
              @update-matrix-data="updateMatrixData()"
              @update-matrix="getMatrix()"
            ></talent-matrix-setting>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-if="matrix.status" label="Матрица" name="matrix">
          <el-card>
            <talent-matrix-view
              ref="talentMatrixView"
              :matrix="matrix"
              :loading="loading"
              @cell-update="getMatrix()"
              @load-axis-user-positions="loadAxisUserPositions()"
            ></talent-matrix-view>
          </el-card>
        </el-tab-pane>
        <el-tab-pane v-if="matrix.status" label="Табличный вид" name="table">
          <el-card>
            <talent-matrix-table-view
              ref="talentMatrixTableView"
              :matrix="matrix"
            ></talent-matrix-table-view>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading";
import BackLink from "@/components/BackLink.vue";
import TalentMatrixSetting from "@/modules/talentMatrix/components/TalentMatrixSetting.vue";
import TalentMatrixView from "@/modules/talentMatrix/components/TalentMatrixView.vue";
import TalentMatrixTableView from "@/modules/talentMatrix/components/TalentMatrixTableView.vue";
import UserGroupSelect from "@/components/filters/users/UserGroupSelect.vue";
import {mapGetters} from "vuex";

export default {
  name: 'talent-matrix',
  components: {
    UserGroupSelect,
    TalentMatrixTableView,
    BackLink,
    PageHeading,
    TalentMatrixSetting,
    TalentMatrixView,
  },
  data() {
    return {
      tabValue: 'matrix',
      loading: false,
      matrix: {
        type: Object,
        default: {},
      },
    }
  },
  mounted() {
    this.getMatrix();
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    getMatrix() {
      this.loading = true;
      this.$api.talentMatrix.matrixGet({
        id: this.$route.params.id,
        expand: ['permissions', 'import_productivity_count', 'import_potential_count'].join(),
      })
        .then(data => {
          this.matrix = data.matrix;

          if (this.$canAndRulesPass(this.matrix, 'talent_matrix.matrix_update')) {
            this.tabValue = 'matrix_setting';
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateMatrixData() {
      this.getMatrix();
      this.$refs.talentMatrixTableView.loadAxisUserPositions();
      this.$refs.talentMatrixView.loadAxisUserPositions();
    },
    loadAxisUserPositions() {
      if (this.$refs.talentMatrixTableView) {
        this.$refs.talentMatrixTableView.loadAxisUserPositions();
      }
    },
  }
}
</script>

<style scoped>

</style>